import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberRelationshipStatus } from '../../../models/users/dto/member-relationship-status';
import { RelationshipStatus } from '../../../models/enum/shared/relationship-status';
import { RelationshipStatusEffectiveDateLabelPipe } from '../../../pipes/relationship-status-effective-date-label.pipe';
import { DatePipe, NgIf } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-relationship-effective-date-review-entry',
  templateUrl: './relationship-effective-date-review-entry.component.html',
  styleUrls: ['./relationship-effective-date-review-entry.component.scss'],
  standalone: true,
  imports: [RelationshipStatusEffectiveDateLabelPipe, DatePipe, NgbTooltip, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelationshipEffectiveDateReviewEntryComponent {
  @Input() relationshipStatus!: MemberRelationshipStatus;

  public tooltipText = $localize`The date when a couple begins living together in a conjugal relationship`;

  protected readonly RelationshipStatus = RelationshipStatus;
}
